export default "__VITE_ASSET__CDHf7z7D__"